import { IconTaskTypes } from '@urbanx/agx.ui-components2';
import TaskDueDateBadge from 'components/tasks/TaskDueDateBadge';
import { BlockerLayout } from 'pages/allTasks/TaskBlockers/BlockerLayout';
import TaskModalEntry from 'pages/allTasks/TaskModal/TaskModalEntry';
import { useTaskModalState } from 'pages/allTasks/TaskModal/useTaskModalState';
import {
  ExchangeTaskGroup,
  getExchangeDisplayTask,
  hasPendingExchangeTasks,
} from './ExchangeTask.shared';
import ExchangeTaskModal from './ExchangeTaskModal';

interface ExchangeTaskEntryProps {
  actionButtonId: string;
  campaignId: string;
  group: ExchangeTaskGroup;
  panelKey: string;
  title: string;
}

const ExchangeTaskEntry = ({
  actionButtonId,
  campaignId,
  group,
  panelKey,
  title,
}: ExchangeTaskEntryProps) => {
  const modalState = useTaskModalState(group.tasks);
  const task = getExchangeDisplayTask(group.tasks);
  const isPendingExchange = hasPendingExchangeTasks(group);

  if (!task) return null;

  return (
    <>
      <ExchangeTaskModal
        campaignId={campaignId}
        isOpen={modalState.isOpen}
        onClose={modalState.close}
        tasks={modalState.modalTasks}
        title={title}
      />
      <TaskModalEntry
        title={title}
        tasks={group.tasks}
        badge={
          <TaskDueDateBadge
            dueDate={(task.dueUtc ?? '') as string}
            isCompleted={task.isCompleted === true}
          />
        }
        iconType={IconTaskTypes.AwaitingExchange}
        actionText="Complete Exchange"
        actionButtonId={actionButtonId}
        panelKey={panelKey}
        blockerContent={isPendingExchange ? <BlockerLayout task={task} /> : undefined}
        onAction={modalState.open}
      />
    </>
  );
};

export default ExchangeTaskEntry;
